/**
 * @file 产品详情
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    GET_PAGES_DATABYID,
    GET_SERVICE_INTRODUCE,
    POST_PRODUCT_ID,
    GET_SCAN_SERVERVICE,
    FETCH_CHACK_AI_IMAGE,
    FETCH_CHACK_AI_INSDUSTRY
} from './ActionTypes';

export function fetchPagesDataById(dispatch, id) {
    return rcAjax('GET', '/cmsapi/getPagesDataById', {id: id}, {}, data => {
        dispatch({type: GET_PAGES_DATABYID, data: data.data});
    });
}

export function fetchServiceIntroduce(dispatch, id) {
    return rcAjax('GET', '/cmsapi/getServiceIntroduceByItemid', {itemid: id}, {}, data => {
        dispatch({type: GET_SERVICE_INTRODUCE, data: data.data});
    });
}

export function fetchProductId(dispatch, id) {
    dispatch({type: POST_PRODUCT_ID, data: {id: id}});
}


export function fetchScanService(params) {
    return function (dispatch) {
        return rcAjax('GET', '/xiapi/api/v1/activity/getServicesV2', params, {}, data => {
            dispatch({type: GET_SCAN_SERVERVICE, data: data.data});
        });
    };
}

// 深度检测
export function fetchChackAiImage(obj) {
    return function (dispatch) {
        return rcAjax(
            'POST',
            '/xiapi/api/v1/deepface/deepfakes',
            {},
            obj,
            data => {
                dispatch({type: FETCH_CHACK_AI_IMAGE, data: data.data});
            });
    };
}

// ai 安防
export function fetchChackAiIndustry(obj) {
    return function (dispatch) {
        return rcAjax(
            'POST',
            '/xiapi/api/v1/industry/detect',
            {},
            obj,
            data => {
                dispatch({type: FETCH_CHACK_AI_INSDUSTRY, data: data.data});
            });
    };
}

// 获取组织id
export function getInstanceId(obj) {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/instance/getInstance',
        {},
        obj,
        () => null
    ).then(data => data.data);
}

// 创建免费poc
export function applyInspectionForm(obj) {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/industry/authCompany',
        {},
        obj,
        () => null
    ).then(data => data.data);
}

// 网址安全检测获取套餐
export function fetchGetServices(json) {
    return rcAjax(
        'GET',
        '/xiapi/api/v1/bsb/get_open_services',
        json,
        {},
        () => null
    ).then(data => data.data);
}

// 网址安全检查询
export function fetchBsbCheck(obj) {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/bsb/check',
        {},
        obj,
        () => null
    ).then(data => data.data);
}

// 文本变体检测
export function fetchVariantCheck(obj) {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/variant/check',
        null,
        obj,
        () => null
    ).then(data => data.data);
}



// WEBPACK FOOTER //
// ./src/actions/productAction.js